import { LimitTypography } from '@aibees/elephant/components/limit-typography';
import {
  Icon,
  InternalLinkButton,
  TextEllipsis,
} from '@aibees/shared/components';
import { useSearch } from '@aibees/shared/context';
import { classnames } from '@aibees/shared/utils';
import { Box, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { RecommendationsItemProps as Props } from './types';

export const RecommendationsItem = memo(({ className, item, index }: Props) => {
  const { search } = useSearch();
  return (
    <Styled.Wrapper
      className={classnames('RecommendationsItem', className)}
      sx={SX.root}
    >
      <Styled.Card key={index}>
        <Stack direction="column" gap={2}>
          <Stack direction="row" gap={2}>
            <Styled.Image src={item.logo_url}>
              <Icon sxx={SX.icon} size={21} name="apartment-rounded" />
            </Styled.Image>
            <Stack sx={{ width: '100%' }}>
              <InternalLinkButton to="TODO">
                <Typography sx={SX.title}>{item.name}</Typography>
              </InternalLinkButton>
              <TextEllipsis w="256px" sx={SX.degree}>
                {item.title}
              </TextEllipsis>

              <Typography sx={SX.duration}>{item.date}</Typography>
            </Stack>
          </Stack>
          <Box>
            <LimitTypography
              value={item.description || ''}
              wordLimit={20}
              sx={{
                fontSize: (p) => p.typography.caption,
                color: (p) => p.palette.grey[500],
              }}
              buttonSX={{
                fontSize: (p) => p.typography.caption.fontSize,
                fontWeight: 700,
              }}
              search={search}
            />
          </Box>
        </Stack>
      </Styled.Card>
    </Styled.Wrapper>
  );
});

RecommendationsItem.displayName = 'RecommendationsItem';
